import url from './url';



export default url(() => '/templates/visualizations/create');
